module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kanto-3-c133fb43cf2b7fa857d5f6bbe0e1f4e5.jpg";